
import { Component, Mixins } from "vue-property-decorator";
import { getBookings } from "@/repositories/Contracts/BookingsRepository";
import FilterableTransactionDetail from "@/components/Base/FilterableTransactionDetail/FilterableTransactionDetail.vue";
import ViewBookingsFilter from "@/components/Contracts/Bookings/ViewBookingsFilter.vue";
import Booking from "@/interfaces/Contracts/Booking";
import FilterableTransactionDetailMixin from "@/mixins/FilterableTransactionDetailMixin";
import AccountMonitorMixin from "@/mixins/AccountMonitorMixin";
import { BookingFilter } from "@/interfaces/Contracts/BookingFilter";
import { getCurrentDate, getIsoDateString } from "@/helpers/Dates/DateHelpers";
import ViewBookingsCardListDetail from "@/components/Contracts/Bookings/ViewBookingsCardListDetail.vue";
import BookingsRepoFilter from "@/interfaces/Repository/Contracts/BookingsRepoFilter";
import { PredefinedDateRangeType } from "@/enumerations/Dates/DateRangePredefined/PredefinedDateRangeType";
import BaseToolbar from "@/components/Base/Toolbar/BaseToolbar.vue";

@Component({
  components: {
    FilterableTransactionDetail,
    ViewBookingsFilter,
    ViewBookingsCardListDetail,
    BaseToolbar,
  },
})
export default class ViewBookings extends Mixins(
  FilterableTransactionDetailMixin,
  AccountMonitorMixin
) {
  bookings = [] as Booking[];
  showChart = true;

  created() {
    this.filter = {
      effectiveDateSelection: {
        isCustomDateRange: false,
        predefinedDateRangeTypeValue: PredefinedDateRangeType.AllDates,
        customFromDate: getIsoDateString(getCurrentDate()),
        customEndDate: getIsoDateString(getCurrentDate()),
        repositoryFromDate: getIsoDateString(getCurrentDate()),
        repositoryEndDate: getIsoDateString(getCurrentDate()),
      },
      expireDateSelection: {
        isCustomDateRange: false,
        predefinedDateRangeTypeValue: PredefinedDateRangeType.OneYear,
        customFromDate: getIsoDateString(getCurrentDate()),
        customEndDate: getIsoDateString(getCurrentDate()),
        repositoryFromDate: getIsoDateString(getCurrentDate()),
        repositoryEndDate: getIsoDateString(getCurrentDate()),
      },
      status: "O",
    } as BookingFilter;
  }

  mounted() {
    this.loadData();
  }

  async loadData(): Promise<void> {
    this.loading = true;

    await getBookings({
      status: this.filter.status,
      fromEffectiveDate: this.filter.effectiveDateSelection.repositoryFromDate,
      toEffectiveDate: this.filter.effectiveDateSelection.repositoryEndDate,
      fromExpireDate: this.filter.expireDateSelection.isCustomDateRange
        ? this.filter.expireDateSelection.customFromDate
        : null,
      toExpireDate: this.filter.expireDateSelection.isCustomDateRange
        ? this.filter.expireDateSelection.customToDate
        : null,
    } as BookingsRepoFilter)
      .then((response) => {
        if (response) {
          this.bookings = response.data;
        }
      })
      .finally(() => (this.loading = false));
  }
}
